<template>
    <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex md6 sm12>
              <search v-model="search"/>
            </v-flex>
            <v-flex md3 sm6>
              <v-checkbox v-model="showDecommissionedOnly">
                <template v-slot:label>Show decommissioned containers only</template>
              </v-checkbox>
            </v-flex>
            <v-flex md3 sm6 class='text-right'>
              <v-menu class="pr-n2 mr-5">
                <template v-slot:activator="{ on }">
                  <v-btn small tile v-on="on" class="mt-4">
                    <v-icon>save_alt</v-icon>&nbsp;Export
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="exportCsv()">
                    <v-list-item-title>
                      <v-icon>grid_on</v-icon>&nbsp;Excel (CSV)
                      <v-chip x-small>limit {{maxRowsPerCsv}} rows</v-chip>
                    </v-list-item-title>
                </v-list-item>
                </v-list>
              </v-menu>
              <v-btn color="primary" @click="openAdd" v-if="userIsFleetOrWorkshopManager" class="mt-4">Add Container</v-btn>
            </v-flex>
          </v-layout>
            <v-dialog persistent v-model="dialog" max-width="500px">
                <ContainerForm
                    v-model="model"
                    :filter-garages="userGarages"
                    @add="submitAdd($event.id, $event.model)"
                    @edit="submitEdit($event.id, $event.model)"
                >
                    <template v-slot:header>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog=false" icon text>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:actions>
                        <v-btn @click="dialog=false">Cancel</v-btn>
                    </template>
                </ContainerForm>
            </v-dialog>
        </v-card-title>
        <v-data-table
            :items="units.data"
            :items-per-page="options.itemsPerPage"
            :headers="headers"
            :loading="$wait.is(['loading units'])"
            :footer-props.sync="footerProps"
            :server-items-length="units.total"
            :options.sync="options"
        >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:item="props">
                <tr>
                    <td>
                        <router-link
                            class="accent--text"
                            :to="{ name: 'unit', params: { unitId: props.item.id } }"
                        >{{ props.item.containerNumber }}
                        </router-link>
                    </td>
                    <td>{{props.item.containerConfiguration}}</td>
                    <td>{{props.item.containerSize}}</td>
                    <td>{{props.item.garageLocation}}</td>
                    <td>{{props.item.description}}</td>
                    <td>{{props.item.isDecommissioned}}</td>
                    <td class="pl-0" v-if="userIsFleetManager || userIsGarageWorkshopManager(props.item.garageLocationId)">
                        <v-btn @click="openEdit(props.item)" icon>
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn v-if="userIsFleetManager" @click="confirmDelete(props.item)" icon small color="red">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                    <td width="76px" class="pl-0" v-if="!userIsFleetManager && !userIsGarageWorkshopManager(props.item.garageLocationId)"></td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-layout row align-center>
                    <v-flex>No matching records found</v-flex>
                </v-layout>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
  import Search from '../Search.vue';
  import ContainerForm from '@/components/Containers/ContainerForm.vue';
  import Units from '@/components/Units/UnitsClient.vue';
  import ContainersClient from '@/components/Containers/ContainersClient';
  import {Event} from '@/plugins/bus';
  import UsersClient from '@/components/Users/UsersClient';
  import moment from 'moment';
  import { DateFormat } from '@/plugins/date-filter';
  import DownloadHelper from '@/lib/DownloadHelper';

  export default {
    components: {
      Search,
      ContainerForm
    },
    mixins: [Units, ContainersClient, UsersClient],
    data() {
      return {
        units: [],
        userGarages: [],
        dialog: false,
        search: this.$route.query.search || '',
        loading: true,
        showDecommissionedOnly: false,
        maxRowsPerCsv: 4000,
        options: {
          itemsPerPage: 50,
          sortBy: ['containerConfiguration']
        },
        footerProps: {
          itemsPerPageOptions: [10, 50, 100]
        },
        headers: [
          {text: 'Number', value: 'containerNumber', sortable: true},
          {text: 'Type', value: 'containerConfiguration', sortable: true},
          {text: 'Size', value: 'containerSize', sortable: true},
          {text: 'Garage Address', value: 'garageLocation', sortable: true},
          {text: 'Description', value: 'description', sortable: false},
          {text: 'Decommissioned', value: 'isDecommissioned', sortable: false},
          {text: '', value: '', sortable: false},
        ],
        model: {},
      };
    },
    computed: {
      params() {
        return {
          pageSize: this.options && this.options.itemsPerPage,
          page: this.options && this.options.page,
          searchTerm: this.search,
          showDecommissionedOnly: this.showDecommissionedOnly,
          orderBy: this.orderBy
        };
      },
      routeQuery() {
        if (this.search) {
          return {search: this.search};
        }
      },
      orderBy() {
        if (this.options.sortBy.length) {
          if (this.options.sortDesc && this.options.sortDesc.length && this.options.sortDesc[0]) {
            return `-${this.options.sortBy[0]}`;
          }
          return this.options.sortBy[0];
        }
        return '';
      }
    },
    methods: {
      async getContainersAndPermissions() {
        if (this.userIsWorkshopManager) {
          const user = await this.getCurrentUser();
          this.userGarages = user.garages;
        } else {
          this.userGarages = [];
        }
        this.units = await this.getContainers();
      },
      userIsGarageWorkshopManager(garageId) {
        return this.userIsWorkshopManagerInGarage(garageId, this.userGarages);
      },
      openAdd() {
        this.model = {};
        this.dialog = true;
      },
      openEdit(container) {
        this.model = {...container}; // spread operator intentionally used to create clone
        this.dialog = true;
      },
      confirmDelete(container) {
        this.$confirmCancel.show(`Delete Container?`, `<p>This will permanently delete this container record</p>`, 'Delete it');
        this.$confirmCancel.$on('confirm-cancel', confirmed => {
          if (!confirmed) {
            return;
          }
          this.$bus.$emit(Event.ContainerPendingDelete, {
            id: container.id,
          });
        });
      },
      goTo(id) {
        this.$router.push({name: 'unit', params: {unitId: id}});
      },
      async submitAdd(id, model) {
        await this.addContainer(id, model);
      },
      async submitEdit(id, model) {
        await this.updateContainer(id, model);
      },
      async handleContainersUpdated(response) {
        if (response.status === 201) {
          this.dialog = false;
        } else if (response.status === 204) {
          this.dialog = false;
        }
        await this.getContainersAndPermissions();
      },
      async handlerContainerDeleted(data) {
        await this.deleteContainer(data.id);
        this.units = await this.getContainers();
      },
      async exportCsv() {
        let searchParams = this.getExportParams();
        searchParams.pageSize = this.maxRowsPerCsv;
        const results = await this.getContainerReportUsingQuery(searchParams);
        const data = results ? results.data : [];
        const rows = data.map(x => [
          x.containerNumber,
          x.alternateNumber,
          x.garageLocation,
          x.department,
          x.containerConfiguration,
          x.containerSize,
          x.description,
          x.firstDayOfService,
          x.isDecommissioned,
          x.decommissionReason,
          x.decommisionReasonOther
        ]);
        const csv = DownloadHelper.makeCsv([
          'Container Number',
          'Alternate Number',
          'Garage Address',
          'Department',
          'Type',
          'Container Size',
          'Description',
          'Container Manufacture Date',
          'Decommissioned - True or False',
          'Decommission Reason',
          'Decommission Text'
        ], rows);
        DownloadHelper.download(`Containers_${moment().format(DateFormat.Canonical)}.csv`, new Blob([csv] ));
      },
      getExportParams() {
        return {
          searchTerm: this.search,
          showDecommissionedOnly: this.showDecommissionedOnly,
          orderBy: this.orderBy
        };
      }
    },
    watch: {
      params: {
        async handler() {
          await this.getContainersAndPermissions();
        },
        deep: true
      },
      search(val) {
        this.$router.push({path: 'containers', query: this.routeQuery});
      }
    },
    async mounted() {
      this.$bus.$on(Event.ContainersUpdated, this.handleContainersUpdated);
      this.$bus.$on(Event.ContainerPendingDelete, this.handlerContainerDeleted);
    },
    async destroyed() {
      this.$bus.$off(Event.ContainersUpdated, this.handleContainersUpdated);
      this.$bus.$off(Event.ContainerPendingDelete, this.handlerContainerDeleted);
    }
  };
</script>
<style>
    td {
        cursor: pointer;
    }
</style>
